import React, { Component } from 'react'
import { Error } from 'react-admin'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { withRouter } from 'react-router'
import {
    MuiThemeProvider,
    createMuiTheme,
    withStyles,
} from '@material-ui/core/styles'
import compose from 'recompose/compose'

import AppBar from './AppBar'
import Sidebar from './Sidebar'
import Menu from './Menu'
import Notification from './Notification'
import defaultTheme from './defaultTheme'

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1,
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        position: 'relative',
        // minWidth: 'fit-content',
        width: '100%',
    },
    appFrame: {
        display: 'flex',
        flexDirection: 'column',
    },
    appbar: {
    //   height: '65px',
        position: 'relative',
        [theme.breakpoints.down('xs')]: {
            marginBottom : 60
        },
    },
    contentWithSidebar: {
        // maxHeight: 'calc(100vh - 100px)',
        display: 'flex',
        flexGrow: 1,
    },
    menu: {
    //   overflowY: 'scroll',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        zIndex : 2,
        padding: theme.spacing.unit * 3,
        [theme.breakpoints.up('xs')]: {
            paddingLeft: 5,
        },
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
        backgroundColor : '#FAFAFA',
        minHeight: 'calc(100vh - 110px)',
        width: '100%'
    },
})

const sanitizeRestProps = ({
    staticContext,
    history,
    location,
    match,
    ...props
}) => props

class Layout extends Component {
    state = { hasError: false, errorMessage: null, errorInfo: null }

    constructor(props) {
        super(props)
        props.history.listen(() => {
            if (this.state.hasError) {
                this.setState({ hasError: false })
            }
        })
    }

    componentDidCatch(errorMessage, errorInfo) {
        this.setState({ hasError: true, errorMessage, errorInfo })
    }

    render() {
        const {
            children,
            classes,
            className,
            customRoutes,
            error,
            dashboard,
            logout,
            open,
            title,
            ...props
        } = this.props
        const { hasError, errorMessage, errorInfo } = this.state
        return (
            <div
                className={classnames('layout', classes.root, className)}
                {...sanitizeRestProps(props)}
            >
                <div className={classes.appFrame}>
                    <div className={classes.appbar}>
                      <AppBar title={title} open={open} logout={logout} />
                    </div>
                    <main className={classes.contentWithSidebar}>
                        <div className={classes.menu}>
                          <Sidebar size={200} closedSize={45}>
                            <Menu logout={logout} hasDashboard={!!dashboard} />
                          </Sidebar>
                        </div>
                        <div className={classes.content}>
                          {hasError
                              ? <Error error={errorMessage} errorInfo={errorInfo} title={title} />
                              : children}
                        </div>
                    </main>
                    <Notification />
                </div>
            </div>
        )
    }
}

const EnhancedLayout = compose(
    connect(
        state => ({ open: state.admin.ui.sidebarOpen }),
        {}, // Avoid connect passing dispatch in props
    ),
    withRouter,
    withStyles(styles),
)(Layout)

class LayoutWithTheme extends Component {
    constructor(props) {
        super(props)
        this.theme = createMuiTheme(defaultTheme)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.theme !== this.props.theme) {
            this.theme = createMuiTheme(nextProps.theme)
        }
    }
    render() {
        const { theme, ...rest } = this.props
        return (
            <MuiThemeProvider theme={this.theme}>
                <EnhancedLayout {...rest} />
            </MuiThemeProvider>
        )
    }
}

export default LayoutWithTheme
